import { StyleSheet, Platform } from 'react-native';
import { isWeb } from '../utils/platformUtils';
import { colors } from './colors';

/** Extra styles to merge onto existing modal footers / buttons on web. */
export const webModalFooterStyle = isWeb
  ? {
      flexDirection: 'row' as const,
      gap: 12,
      marginTop: 24,
      paddingTop: 16,
      borderTopWidth: 1,
      borderTopColor: colors.border,
      justifyContent: 'flex-end' as const,
    }
  : {};

export const webModalButtonRow = StyleSheet.create({
  row: Platform.select({
    web: {
      flexDirection: 'row',
      gap: 12,
      justifyContent: 'flex-end',
    },
    default: {},
  }),
});
